import { Fragment } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import Dashboard from '../Dashboard'

const noDashboardContainerRoutes = [/\/reservations\/\d+$/]

const BuildingDashboard = () => {
  const location = useLocation()

  const noDashboard = noDashboardContainerRoutes.some((regex) => regex.test(location.pathname))

  if (noDashboard) {
    return (
      <Fragment>
        <div className="ctp-dashboard-building-children">
          <Outlet />
        </div>
      </Fragment>
    )
  }

  return (
    <Dashboard.Container className={'BuildingDashboard ctp-dashboard-building-container'}>
      <Fragment>
        <div className="ctp-dashboard-building-children">
          <Outlet />
        </div>
      </Fragment>
    </Dashboard.Container>
  )
}

export default BuildingDashboard
